<template>
<loader v-bind="{ loading }">
    <columns>
      <column>
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </column>
      <column class="is-narrow is-flex align-end">
        <router-link 
          class="button is-small is-rounded"
          :to="{
            name: 'new-vulnerability'
          }">
          <icon icon="plus"/>
          <span>Vulnerability</span>
        </router-link>
      </column>
    </columns>

    <div>
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Vulnerability</th>
              <th>Product</th>
              <th class="is-narrow has-text-right">Published</th>
              <th class="is-narrow has-text-right">Last Updated</th>
              <th class="has-text-right is-narrow">Poc</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vulnerability in vulnerabilities.data" :key="vulnerability.id">
              <td>
                <router-link 
                  :to="{
                    name: 'vulnerability-manager',
                    params: {
                      vulnerability: vulnerability.id
                    }
                  }">
                  <span>{{ vulnerability.cvid }}</span>
                </router-link>
                <p class="has-text-grey">
                  <small>{{ vulnerability.description | truncate(150) }}</small>
                </p>
              </td>
              <td>
                <span v-if="vulnerability.software">{{ vulnerability.software.name }}</span>
                <span v-else>--</span>
              </td>
              <td class="has-text-right">
                <span class="no-wrap">{{ vulnerability.published_at || vulnerability.created_at | date }}</span>
              </td>
              <td class="has-text-right">
                <span class="no-wrap">{{ vulnerability.updated_at | date }}</span>
              </td>
              <td class="has-text-right">
                <yes-no :value="Boolean(vulnerability.pocs_count)"/>
              </td>
            </tr>
          </tbody>
        </table>
        <pager 
          class="mb-1"
          :pageable="vulnerabilities" 
          @nav="goToPage"
          jump-controls
          context="Vulnerability"/>
      </div>
    </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Vulnerabilities',

  data: () => ({
    vulnerabilities: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadVulnerabilities()
  },

  methods: {
    loadVulnerabilities() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.vulnerabilities = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'vulnerabilities',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'vulnerabilities',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadVulnerabilities'
  }

}
</script>
